<template>
    <div>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            key-property="categoryId"
            search-url="/category/onSearchAllStatus?categoryTypeCode=DISEASES&sortField=createAt&"
            create-url="/category/save"
            delete-url="/category/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
        >
        </c-search-form>
        <diseases-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
        />
    </div>
</template>

<script>
import { areaContants } from "@/constants";
import axios from "axios";
import DiseasesCreate from "./DiseasesCreate";
import CSearchForm from "../../../../components/form/ManageForm";

export default {
    name: "warehouse",
    components: {CSearchForm, DiseasesCreate },
    data: () => {
        return {
            formName: "Danh sách bệnh",
            formCreateName: "Thêm mới bệnh",
            category: null,
            visibleCreateDialog: false,
            timeReload: 0,
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "categoryCode",
                    text: "Mã bệnh",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "categoryName",
                    text: "Tên bệnh",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "description",
                    text: "Triệu trứng và phương pháp điều trị",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    sortable: false,
                    compound: true,
                    width: "60px",
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        
    },

    methods: {
        openCreateDialog: function (item = null) {
            if (item == null) {
                this.formCreateName = 'Thêm mới bệnh';
                //this.category = item;
            } else {
                this.category = item;
                this.formCreateName = 'Cập nhật bệnh';
            }
            this.visibleCreateDialog = true;
        },
        closeCreateDialog: function () {
            this.category = null;
            this.visibleCreateDialog = false;
            this.timeReload = Math.floor(Math.random() * 100);
        },
    },

    destroyed() {},
};
</script>
